import React, { useEffect } from 'react';
import { bool, node, string, shape } from 'prop-types';
import { Route, useHistory } from 'react-router-dom';
import { routes } from '@constants';
import { storage } from '@utils';

const UnauthorizedRoute = ({ exact, path, children, location }) => {
  const history = useHistory();
  const token = storage.getToken();

  useEffect(() => {
    if (token) {
      history.push(routes.home);
    }
  }, []);

  return (
    <Route exact={exact} path={path} location={location}>
      {children}
    </Route>
  );
};

UnauthorizedRoute.defaultProps = {
  exact: false,
  location: undefined,
};

UnauthorizedRoute.propTypes = {
  exact: bool,
  path: string.isRequired,
  children: node.isRequired,
  location: shape({}),
};

export default UnauthorizedRoute;
